'use-client';
import * as React from 'react';
import type { VerticalLineProps } from '../VerticalLine';
import type { IVerticalLineProps } from '../../../VerticalLine.types';
import VerticalLine from '../../VerticalLine';
import skinsStyle from './styles/VerticalArrowLine.scss';
import { BaseVerticalLine } from './BaseVerticalLine';

const VerticalArrowLineSkin: React.FC<VerticalLineProps> = props => (
  <BaseVerticalLine {...props} skinsStyle={skinsStyle} />
);

const VerticalArrowLine: React.FC<Omit<IVerticalLineProps, 'skin'>> = props => {
  return <VerticalLine {...props} skin={VerticalArrowLineSkin} />;
};

export default VerticalArrowLine;
